<div
  [ngClass]="{hasBackground: customSettings.background}"
  [backgroundImage]="env.storage_path+customSettings.background"
  class="selectiveProcessContainerPage"
  fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="center center" fxFill>
    <div *ngIf="proccessOptions.length"
      fxFlex="45"
      class="selectiveProcessContent">
      <div class="rbPadding20x20" fxLayoutAlign="center center">
        <h2>Escolha o processo seletivo</h2>
      </div>
      <div class="rbPadding20x20">
        <mat-form-field appearance="standard"
        class="rb-white-form-field"
        [ngClass]="{hasBackground: customSettings.background}"
        fxFlex="">
          <mat-label class="rb-label-black">Selecione uma opção</mat-label>
          <mat-select matInput
            disableOptionCentering
            panelClass="ps-selective-proccess-select"
            required
            [(ngModel)]="proccessData">
            <mat-option *ngFor="let option of proccessOptions" [value]="option" >
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="rbPadding20x20" fxLayoutAlign="center center">
        <button
          (click)="redirect(proccessData.id)"
          mat-raised-button color="primary"
          [disabled]="!proccessData.id">
          Iniciar inscrição
        </button>
      </div>
  </div>
  <div class="selectiveProcessContent" fxLayoutAlign="center center" *ngIf="!proccessOptions.length">
    <div class="rbPadding20x20 infoContent" fxLayoutAlign="space-between center" fxLayout="column">
      <svg width="100" height="100" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M19.8486 0.622803C9.25638 0.622803 0.626953 9.25224 0.626953 19.8444C0.626953 30.4366 9.25638 39.0661 19.8486 39.0661C30.4408 39.0661 39.0702 30.4366 39.0702 19.8444C39.1041 9.25224 30.4746 0.622803 19.8486 0.622803ZM19.8486 37.171C10.3055 37.171 2.55588 29.3876 2.55588 19.8444C2.55588 10.3013 10.3393 2.51789 19.8824 2.51789C29.4256 2.51789 37.209 10.3013 37.209 19.8444C37.1751 29.3876 29.3917 37.171 19.8486 37.171Z"
          [ngStyle]="{'fill' : customSettings.institutional_color}"
        />
        <path
          d="M21.5382 10.2336H18.4248V23.0932H21.5382V10.2336Z"
          [ngStyle]="{'fill' : customSettings.institutional_color}"
        />
        <path
          d="M21.5382 26.511H18.4248V29.489H21.5382V26.511Z"
          [ngStyle]="{'fill': customSettings.institutional_color}"
        />
      </svg>
      <h2>Não há nenhum processo seletivo disponível para inscrição no momento.</h2>
    </div>
  </div>
</div>
